import { render, staticRenderFns } from "./activity-details.vue?vue&type=template&id=28e44082&scoped=true&functional=true&"
import script from "./activity-details.vue?vue&type=script&lang=js&"
export * from "./activity-details.vue?vue&type=script&lang=js&"
import style0 from "./activity-details.vue?vue&type=style&index=0&id=28e44082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "28e44082",
  null
  
)

component.options.__file = "activity-details.vue"
export default component.exports